export interface OpenInvite {
  state: 'open';
  name: string;
  householdName: string | null;
  email: string | null;
  phone: string | null;
  maxPartySize: number;
}

export interface SubmittedInvite {
  state: 'submitted';
  rsvpStatus: 'yes' | 'no';
  attendeeCount: number;
  email: string | null;
  phone: string | null;
  jeffismSubmitted: boolean;
}

export type PublicInvite = OpenInvite | SubmittedInvite;

export interface EventDetails {
  title: string; date: string; startTime: string; endTime: string; guestArrivalTime: string; honoreeArrivalTime: string;
  venueName: string; address: string; mapUrl: string; rsvpDeadline: string; surpriseParty: boolean;
  eventNotes: { arrival: string; parking: string; attire: string; food: string };
}

export class RequestError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init?.headers },
  });
  const body = await response.json().catch(() => ({})) as { error?: { code?: string; message?: string } };
  if (!response.ok) throw new RequestError(response.status, body.error?.code || 'REQUEST_FAILED', body.error?.message || 'Request failed.');
  return body as T;
}
